module.exports = __webpack_public_path__ + "img/print.c9bffdf7.svg";